import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// new Password Redux States
import { BULKIMPORT_SET, CANDIDATE_SET, DELETE_ALL_DESCRIPTIONS, DELETE_ALL_RESUMES, DELETE_JD_REPOSITORY, GET_CANDIDATE_BULK_IMPORT_STATUS, GET_JOB_BULK_IMPORT_STATUS, GET_JOB_PROFILES, GET_JOB_PROFILES_SUGGESTION, GET_SAMPLE_CSV_JD_FILE, GET_SAMPLE_CSV_RESUME_FILE, JOB_SET, ORG_DETAIL_GET_LIST } from "./actionTypes"
import {
  bulkimportSetError,
  bulkimportSuccess,
  deleteAllDescriptionsFailed,
  deleteAllDescriptionsSuccess,
  deleteAllResumesFailed,
  deleteAllResumesSuccess,
  deleteJdRepositoryFailed,
  deleteJdRepositorySuccess,
  getCandidateBulkImportStatusFailed, getCandidateBulkImportStatusSuccess,
  getJobBulkImportStatusFailed,
  getJobBulkImportStatusSuccess,
  getJobProfilesFailed,
  getJobProfilesSuccess,
  getOrgListError,
  getOrgListSuccess,
  getSampleJdFileFailure,
  getSampleJdFileSuccess,
  getSampleResumeFileFailure,
  getSampleResumeFileSuccess,
  jobBulkimportJobProfileSuggestionsError,
  jobBulkimportJobProfileSuggestionsSuccess
} from "./actions"
//Include Both Helper File with needed methods
import { PostOrganizationList, getAllCounties, getRequest, postBulkimport, postBulkimportmultipart } from "../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../common/constant/constantURL"

function* bulkimportmultipart({ payload: { user } }) {
try{
  
  var url;
  var data=JSON.parse(localStorage.getItem("authUser"));
  if(data.userType==="Recruiter")
  {
    
    url=constClass.REST_API_RECRUITER_BULKIMPORTUNZIP;
  }
  else
  {
    url= constClass.REST_API_BULKIMPORTUNZIP;
  }
     const response = yield call(postBulkimportmultipart, url, user)
    if(response==="" ||response.length<1){
      yield put(bulkimportSetError("Unexcepted error"))
    }else{
 yield put(bulkimportSuccess(response))
    }
    
}catch (error) {
    yield put(bulkimportSetError(error))
  }

}

function* candidateBulkimport({ payload: { user } }) {
  try{
    
      var url;
      var data=JSON.parse(localStorage.getItem("authUser"));
     if(data.userType==="Recruiter")
     {
       
       url=constClass.REST_API_RECRUITER_BULKIMPORT;
     }
     else
     {
       url=constClass.REST_API_BULKIMPORT;
     }
           
       const response = yield call(postBulkimport,url, user)
   
       yield put(bulkimportSuccess(response))
  }catch (error) {
      yield put(bulkimportSetError(error))
    }
  
  }

  function* getOrgList({payload:{orgDetail}}){
    try 
    {
      var url = constClass.REST_API_RECRUITER_ORGANIZATION_LIST
      const response = yield call(PostOrganizationList, url,orgDetail)
      yield put(getOrgListSuccess(response))
    }
    catch (error) {
      yield put(getOrgListError(error))
    }
  }

function* jobBulkimport({ payload: { user } }) {
  try{
  
    var url;
    let data = JSON.parse(localStorage.getItem("authUser"));
    if(data.userType==="Recruiter")
    {
      
      url=constClass.REST_API_RECRUITER_JOB_BULKIMPORT;
    }
    else
    {
      url=constClass.REST_API_JOB_BULKIMPORT;
    } 
    

       const response = yield call(postBulkimport, url, user)

       yield put(bulkimportSuccess(response))
  }catch (error) {
      yield put(bulkimportSetError(error))
    }
  
  }

  function* getJobProfilesHandler({payload:{data}}){
    try{
      var url
      if (data.keyword ===""){
         url=constClass.REST_API_GET_JOB_PROTILES+data.page;

      }
      else{
         url=constClass.REST_API_GET_JOB_PROTILES+data.page+"&keyword="+data.keyword;

      }
      const response = yield call(getAllCounties, url)

       yield put(getJobProfilesSuccess(response))



    }
    catch(error){
      yield put(getJobProfilesFailed(error))


    }
  }

  function* getCandidateBulkImportStatusHandler({payload:{id}}){
    try{
      var url=constClass.REST_API_GET_CANDIDATE_RESUME_STATUS+id;
      const response = yield call(getAllCounties, url)

       yield put(getCandidateBulkImportStatusSuccess(response))



    }
    catch(error){
      yield put(getCandidateBulkImportStatusFailed(error))


    }
  }

  function* deleteAllResumesHandler({payload:{id}}){
    try{
      var url=constClass.REST_API_GET_CANDIDATE_RESUME_STATUS+id+"&delete=1"
      const response = yield call(getAllCounties, url)
      yield put(deleteAllResumesSuccess(response))

    }
    catch(error){
      yield put(deleteAllResumesFailed(error))

    }

  }

  function* getJobBulkImportStatusHandler({payload:{id}}){
    try{
      var url=constClass.REST_API_GET_JOB_DESCRIPTION_STATUS+id;
      const response = yield call(getAllCounties, url)

       yield put(getJobBulkImportStatusSuccess(response))



    }
    catch(error){
      yield put(getJobBulkImportStatusFailed(error))
    }
  }

  function* deleteAllDescriptionsHandler({payload:{id}}){
    try{
      var url=constClass.REST_API_GET_JOB_DESCRIPTION_STATUS+id
      const response = yield call(getAllCounties, url)
      yield put(deleteAllDescriptionsSuccess(response))

    }
    catch(error){
      yield put(deleteAllDescriptionsFailed(error))

    }

  }

   
  function* deleteJdRepositoryHandler({payload:{id}}){
    try{
      var url=constClass.REST_API_GET_DELETE_JD_LIST+`${id}`
      const response = yield call(getAllCounties, url)
      yield put(deleteJdRepositorySuccess(response))

    }
    catch(error){
      yield put(deleteJdRepositoryFailed(error))

    }

  }
 
   
  function* jobBulkimportJobProfileSuggestions({payload:{keyword}}){
    try{
      var url=constClass.REST_API_GET_JOB_PROFILE_SUGGESTION+keyword
      const response = yield call(getRequest, url)
      yield put(jobBulkimportJobProfileSuggestionsSuccess(response))

    }
    catch(error){
      yield put(jobBulkimportJobProfileSuggestionsError(error))

    }

  }

  function* sampleJdHandler(){
    try{
      var url=constClass.REST_API_GET_JD_CSV_FILE
      const response = yield call(getRequest, url)
      yield put(getSampleJdFileSuccess(response))

    }
    catch(error){
      yield put(getSampleJdFileFailure(error))
    }
  }

  function* sampleResumeHandler(){
    try{
      var url=constClass.REST_API_GET_RESUME_CSV_FILE
      const response = yield call(getRequest, url)
      yield put(getSampleResumeFileSuccess(response))

    }
    catch(error){
      yield put(getSampleResumeFileFailure(error))
    }
  }

function* bulkimportsaga() {
  yield takeEvery(BULKIMPORT_SET, bulkimportmultipart)
  yield takeEvery(CANDIDATE_SET, candidateBulkimport)
  yield takeEvery(JOB_SET, jobBulkimport)
  yield takeEvery(ORG_DETAIL_GET_LIST , getOrgList)
  yield takeEvery(GET_JOB_PROFILES,getJobProfilesHandler)
  yield takeEvery(GET_CANDIDATE_BULK_IMPORT_STATUS,getCandidateBulkImportStatusHandler)
  yield takeEvery(DELETE_ALL_RESUMES,deleteAllResumesHandler)
  yield takeEvery(GET_JOB_BULK_IMPORT_STATUS,getJobBulkImportStatusHandler)
  yield takeEvery(DELETE_ALL_DESCRIPTIONS,deleteAllDescriptionsHandler)
  yield takeEvery(DELETE_JD_REPOSITORY, deleteJdRepositoryHandler)
  yield takeLatest(GET_JOB_PROFILES_SUGGESTION, jobBulkimportJobProfileSuggestions)
  yield takeLatest(GET_SAMPLE_CSV_JD_FILE,sampleJdHandler)
  yield takeLatest(GET_SAMPLE_CSV_RESUME_FILE,sampleResumeHandler)
  }


  export default bulkimportsaga